<template>
  <div>
    <v-expansion-panels
      elevation="0"
      style="padding: 30px; border-radius: 20px"
    >
      <v-expansion-panel>
        <v-expansion-panel-header style="padding: 35px;">
          <h3 style="color:#42352E;">Busqueda detallada</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form ref="form" v-model="formValido" lazy-validation>
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="form.alianza_intermx_id"
                  :items="alianzas"
                  item-text="nombre"
                  item-value="id"
                  label="Seleccionar Alianza"
                  outlined
                  dense
                  background-color="white"
                  :rules="[(v) => !!v || 'Este campo es requerido']"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="form.producto_id"
                  :items="productos"
                  item-text="nombre"
                  item-value="id"
                  label="Producto"
                  outlined
                  dense
                  background-color="white"
                  :rules="[(v) => !!v || 'Este campo es requerido']"
                />
              </v-col>

              <v-file-input
                v-model="archivo"
                label="Archivo CSV"
                prepend-icon="mdi-paperclip"
                outlined
                dense
                background-color="white"
                accept=".csv"
                :rules="[
                  (v) => !!v || 'Debe subir un archivo',
                  (v) =>
                    !v || v.name.endsWith('.csv') || 'El archivo debe ser CSV',
                ]"
                :disabled="!form.alianza_intermx_id || !form.producto_id"
              />

              <v-col cols="12" class="text-end">
                <v-btn
                  dark
                  color="#00a7e4"
                  rounded
                  class="mr-2"
                  min-width="120"
                  :loading="loading"
                  @click="validarYProcesarArchivo"
                  :disabled="
                    !form.alianza_intermx_id ||
                      !form.producto_id ||
                      !archivo ||
                      !esCSV ||
                      loading
                  "
                >
                  Almacenar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { getProductosByAlianza } from "@/services/productos/product.service";
import { getAlianzas } from "@/services/alianzas/alianzas.service.js";
import { postCargarArchivoFacturacionAlianzaGenericas } from "@/services/emision/emision.service";
export default {
  watch: {
    "form.alianza_intermx_id"() {
      this.getProductosList();
    },
  },
  data() {
    return {
      form: {
        alianza_intermx_id: null,
        producto_id: null,
      },
      alianzas: [],
      productos: [],
      archivo: null,
      formValido: true,
      archivoValido: false,
      datosDelArchivo: [],
      loading: false,
    };
  },
  mounted() {
    this.getAlianzasList();
  },
  computed: {
    esCSV() {
      if (!this.archivo) return false;
      return this.archivo.name.toLowerCase().endsWith(".csv");
    },
  },
  methods: {
    async getAlianzasList() {
      this.alianzas = await getAlianzas();
    },
    async getProductosList() {
      if (this.form.alianza_intermx_id == null) return;
      this.productos = await getProductosByAlianza(
        this.form.alianza_intermx_id,
      );
    },

    async validarYProcesarArchivo() {
      if (!this.archivo) {
        this.$toast.error("Debes seleccionar un archivo.");
        return;
      }

      this.loading = true;

      try {

        await postCargarArchivoFacturacionAlianzaGenericas(
          this.archivo,
          this.form.alianza_intermx_id,
          this.form.producto_id,
        );

        this.$toast.success(
          "Archivo enviado correctamente, espera a que se procese.",
        );
        setTimeout(() => {
          location.reload();
          this.loading = false;
        }, 3000);
      } catch (error) {
        console.error(error);
        this.$toast.error("Error al enviar el archivo.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.v-expansion-panel {
  border-radius: 20px;
}

.v-expansion-panels {
  z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
  background-color: #f7f8fa;
}

.v-expansion-panel-header {
  background-color: #f7f8fa;
  border-radius: 20px !important;
}

@media (max-width: 600px) {
  .button-container {
    margin-bottom: 15px;
    /* Ajusta el espacio */
  }
}
</style>
